import { render, staticRenderFns } from "./RegionalOfficerComments.vue?vue&type=template&id=70f3948a&scoped=true&"
import script from "./RegionalOfficerComments.vue?vue&type=script&lang=js&"
export * from "./RegionalOfficerComments.vue?vue&type=script&lang=js&"
import style0 from "./RegionalOfficerComments.vue?vue&type=style&index=0&id=70f3948a&lang=scss&scoped=true&"
import style1 from "./RegionalOfficerComments.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f3948a",
  null
  
)

export default component.exports